<template>
  <div v-if="isGranted('VIEW_LABELS')">
    <q-btn-group rounded>
      <q-btn
        icon="far fa-lightbulb"
        :color="total ? 'primary' : undefined"
        :text-color="total ? 'white' : undefined"
        class="q-py-sm"
        @click="openLabelFilter"
      >
        <span
          v-if="total"
          class="q-ml-sm"
        >{{ total }}</span>
        <q-tooltip>Filter by Insights</q-tooltip>
      </q-btn>
      <q-btn
        v-if="total"
        icon="fa fa-times"
        class="q-py-sm"
        @click="clear"
      >
        <q-tooltip>Clear label filter</q-tooltip>
      </q-btn>
    </q-btn-group>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { openDrawer } from '@/layout';
import isGranted from '@/auth/isGranted';
import { LabelSelection } from '@/analysis/types';
import LabelFilterSidebar from './LabelFilterSidebar.vue';
import { countSelected, emptySelection } from './selection';

export default defineComponent({
  emits: ['update:modelValue'],
  props: {
    clientId: {
      type: Number,
      required: true,
    },
    modelValue: {
      type: Object as () => LabelSelection,
      default: () => emptySelection(),
    },
  },
  computed: {
    total(): number {
      return countSelected(this.modelValue);
    },
  },
  methods: {
    isGranted,
    openLabelFilter() {
      openDrawer({
        component: LabelFilterSidebar,
        props: {
          clientId: this.clientId,
          value: this.modelValue,
        },
        on: {
          'update:value': (selection: LabelSelection) => {
            this.$emit('update:modelValue', selection);
          },
        },
        paddless: true,
        closable: false,
        width: '360px',
      });
    },
    clear() {
      this.$emit('update:modelValue', emptySelection());
    },
  },
});
</script>
